import React, { useEffect } from "react";
import { Image, Progress } from "antd";
import "./OverallResultad.scss";
import styles from "../../styles/dashboard.module.scss";
import Text from "antd/lib/typography/Text";

function OverallResultAd({ overallLevel }: any) {
  useEffect(() => {
    console.log(overallLevel?.summary_report, "summary_report");
  }, [overallLevel]);

  const isDemo = JSON.parse(localStorage.getItem("Demo_check") ?? "false");

  const summary_demo = `
<p>The organization-wide Wellness Index rose to 74.2 this month, up from 71.8 in February and 69.5 in January, reflecting a sustained upward trajectory across most departments. Happiness scores improved notably in Engineering (up 6.3%) and Operations (up 4.1%), correlating with reduced absenteeism in both teams. The overall absenteeism rate dropped to 3.2% from 4.7% two months ago. Productivity indices across the organization held steady at 78.6, with Engineering recording its highest output score in three quarters. These patterns suggest that the wellness interventions introduced last quarter are beginning to yield measurable returns across the broader workforce.</p>


<p>Engagement scores organization-wide climbed to 72.1, driven primarily by strong gains in HR (up 8.2%) and Marketing (up 5.4%), where team cohesion and role clarity markers showed consistent improvement. Cross-functional collaboration indices also rose by 3.9 points, indicating healthier interdepartmental dynamics. The Operations team, which had flagged moderate disengagement in the prior quarter, has now returned to above-baseline levels for three consecutive weeks. These gains point to a workforce that is increasingly aligned and psychologically invested in its day-to-day work.</p>

<p>However, the Sales department warrants close attention. Engagement in Sales dipped from 68.4 in January to 64.1 in February and has now settled at 61.7, marking a consistent two-month decline. This is accompanied by early attrition signals. Voluntary exit intent, captured through behavioral pattern shifts and sentiment vectorization, has moved into the amber zone for 18% of the Sales team, up from 9% in January. Absenteeism in Sales also ticked up to 5.8%, notably higher than the organizational average. While productivity has not yet dropped sharply (down only 1.3 points), historical patterns across similar datasets suggest that sustained engagement erosion of this kind typically precedes a measurable productivity decline within 4 to 6 weeks if left unaddressed.</p>

<p>Overall, the organization is trending positively on five of six core indices, and the cultural health baseline continues to strengthen. The Sales department trend, however, represents a localized but significant risk that could impact revenue continuity and team stability if intervention is delayed. The data points toward a need for targeted action in Sales, and the platform's recommendation engine has flagged this as a priority area for the upcoming cycle.</p>
`;
 

  const metrics = [
    {
      label: "Wellness Index",
      value: `${overallLevel?.wellnessLevel?.toFixed(1) ?? 0}/8`,
      icon: "/img/new/wellness_icon.svg",
      color: "#b21e49",
      percent: overallLevel?.wellnessLevel
        ? overallLevel.wellnessLevel.toFixed(1) * 10
        : 0,
      size: 205,
      strokeWidth: 6,
      trail: "#fce8f4",
    },
    {
      label: "Happiness Index",
      value: `${overallLevel?.happinessLevel?.toFixed(1) ?? 0}/8`,
      icon: "/img/Happiness.svg",
      color: "#EF8734",
      percent: overallLevel?.happinessLevel
        ? overallLevel.happinessLevel.toFixed(1) * 10
        : 0,
      size: 160,
      strokeWidth: 8,
      trail: "#fef3eb",
    },
    {
      label: "Engagement",
      value: `${overallLevel?.wpengagement_percentage?.toFixed(0) ?? 0}%`,
      icon: "/img/new/engagement_icon.svg",
      color: "#9EC655",
      percent: overallLevel?.wpengagement_percentage ?? 0,
      size: 109,
      strokeWidth: 10,
      trail: "#f0f7e6",
    },
  ];

  return (
    <div className="overall-card">
      {/* ── Header ─────────────────────────────────────────── */}
      <div className={`${styles.white_bg_wrapper} pad_16`}>
        <div className={styles.info_title}>
          <Text className={styles.title}>Overview</Text>
          <Text className={styles.subtitle}>Based on this month's result</Text>
        </div>
        <div className={styles.graph_wrapper}>
          <>
            <div className={styles.graph_info}>
              <div className={styles.info_txt}>
                <Text className={styles.title}>Wellness Index</Text>
                <div className={styles.subtitle}>
                  <Image src="/img/new/wellness_icon.svg" preview={false} />
                  <Text className={styles.title}>
                    {overallLevel?.wellnessLevel?.toFixed(1) ?? 0}/8
                  </Text>
                </div>
              </div>
              <div className={styles.info_txt}>
                <Text className={styles.title}>Happiness Index</Text>
                <div className={styles.subtitle}>
                  <Image src="/img/Happiness.svg" preview={false} />
                  <Text className={styles.title}>
                    {overallLevel?.happinessLevel?.toFixed(1) ?? 0}/8
                  </Text>
                </div>
              </div>
              <div className={styles.info_txt}>
                <Text className={styles.title}>Engagement</Text>
                <div className={styles.subtitle}>
                  <Image src="/img/new/engagement_icon.svg" preview={false} />
                  <Text className={styles.title}>
                    {overallLevel?.wpengagement_percentage?.toFixed(0) ?? 0}%
                  </Text>
                </div>
              </div>
            </div>
            <div className={styles.Progress_graph_wrapper}>
              <div className={styles.graph}>
                <Progress
                  strokeColor={"#9EC655"}
                  trailColor="#FDECED"
                  className={styles.circleOne}
                  size={109}
                  strokeWidth={10}
                  type="circle"
                  percent={overallLevel?.wpengagement_percentage ?? 0}
                  showInfo={false}
                />
                <Progress
                  strokeColor={"#EF8734"}
                  trailColor="#FDECED"
                  className={styles.circleOne}
                  size={160}
                  strokeWidth={8}
                  type="circle"
                  percent={
                    overallLevel?.happinessLevel
                      ? overallLevel?.happinessLevel?.toFixed(1) * 10
                      : 0
                  }
                  showInfo={false}
                />
                <Progress
                  strokeColor={"#b21e49"}
                  trailColor="#FDECED"
                  className={styles.circleOne}
                  strokeWidth={6}
                  size={205}
                  type="circle"
                  percent={
                    overallLevel?.wellnessLevel
                      ? overallLevel?.wellnessLevel?.toFixed(1) * 10
                      : 0
                  }
                  showInfo={false}
                />
              </div>
            </div>
          </>
        </div>
      </div>

      {/* ── Summary ──────────────────────────────────────────── */}
      <div className="overall-card__summary">
        <div className="overall-card__summary-header">
          <span className="overall-card__summary-icon">📋</span>
          <h3 className="overall-card__summary-title">Summary</h3>
        </div>
        <div
          className="overall-card__summary-body"
          dangerouslySetInnerHTML={{
            __html: isDemo ? summary_demo : overallLevel?.summary_report,
          }}
        />
      </div>
    </div>
  );
}

export default OverallResultAd;
